module.exports = __webpack_public_path__ + "static/media/banklogo.d7629cad.svg";